export const envConfig = {
  //INFO: hardcoded option is for github action test environment, where does not exist any env config url
  apiUrl: process.env.REACT_APP_API_URL || 'https://dev-api-myatf.atf.fr/rest',
  donationURl: process.env.REACT_APP_DONATION_URL || 'https://localhost:3001/',
  isDev: !!process.env.REACT_APP_DEV,
};
